<template>
    <div class="tips-breadcrumbs">
        <ul>
            <li v-for="link in breadcrumb" :class="link.routerLinkName ? '': 'active'" :key="link.title">
                <router-link :to="{ name: link.routerLinkName, params: link.params ? link.params : {} }" class="router-link-active">
                    <span>{{ link.title }}</span>
                </router-link>
            </li>
        </ul>

    </div>
</template>

<script>
export default {
    props: {
        /**
         * Expecting the following:
         * [
         *   {
         *      title: String
         *      routerLinkName: String
         *   },
         *   ...
         * ]
        */
        breadcrumb: {
            type: Array,
            required: true
        }
    }
};
</script>

<style lang="scss">
@import "@sass/_variables.scss";

@mixin active-or-hover-route {
    background-color: var(--v-primary-base);
    border-radius: inherit;

    &:after {
        border-left: 12px solid var(--v-primary-base);
    }

    span {
        color: white;
        transition: ease 0.4s;
    }
}

.tips-breadcrumbs {
    margin-bottom: 25px;

    ul {
        display: flex;
        margin: 0;
        padding: 0;
        list-style: none;
        flex-wrap: wrap;
    }

    li {
        position: relative;
        height: 25px;
        background-color: $grey-light;
        border-radius: 4px;

        &:after {
            content: '';
            position: absolute;
            width: 0;
            height: 0;
            top: 0;
            right: -10px;
            border-top: 12.5px solid transparent;
            border-bottom: 12.5px solid transparent;
            border-left: 12px solid $grey-light;
            z-index: 2;
        }

        &:not(:first-child):before {
            content: '';
            position: absolute;
            width: 0;
            height: 0;
            top: 0;
            left: 0;
            border-top: 12.5px solid transparent;
            border-bottom: 12.5px solid transparent;
            border-left: 12px solid $grey-soft;
            z-index: 1;
        }

        &.active,
        &:hover {
            background-color: var(--v-primary-base);

            &:after {
                border-left: 12px solid var(--v-primary-base);
            }

            span {
                color: white;
                transition: ease 0.4s;
            }
        }

        a {
            display: block;
            font-size: 12px;
            line-height: 15px;
            font-weight: 400;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            text-decoration: none !important;
            color: #9e9d9d !important;
            padding: 5px 20px 5px 20px;
        }

        a {
            display: block;
            font-size: 12px;
            line-height: 15px;
            font-weight: 400;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            text-decoration: none !important;
            color: #9e9d9d !important;
            padding: 5px 20px 5px 20px;
        }
    }
}
</style>
